module.exports = __webpack_public_path__ + "static/media/tachometer-alt-slow.c561b5b3.svg";